import { CountUp } from 'countup.js';

export default class Countup {
    static init() {const isNeosBackend = document.body.classList.contains('neos-backend');
        if (isNeosBackend) {
            return;
        }

        Array.from(document.querySelectorAll('.divider-countup .divider__counter-number')).forEach(element => {
            new Countup(element);
        });
    }

    constructor(element) {
        if (!element) return;
        this.element = element;

        let options = this.getOptions(document.querySelector('html').getAttribute('lang'));
        let value = this.element.dataset.count.trim();
        value = value.replace(options.separator, '').replace(options.decimal, '.');
        if(!(new RegExp(/^[0-9.]*$/)).test(value)) {
            return; // not a valid number
        }
        options.decimalPlaces = value.split('.')[1] ? value.split('.')[1].length : 0;

        this.counter = new CountUp(this.element, parseFloat(value), options);

        window.addEventListener('scroll', async () => {
            if (this.isInViewport()) {
                this.animate();
            }
        }, false);
        setTimeout(() => {
            if (this.isInViewport()) {
                this.animate();
            }
        }, 300);
    }

    getOptions(lang) {
        let options = {
            duration: 2,
        };
        switch (lang) {
            case 'cs':
            case 'de':
                return Object.assign(options, {
                    separator: ' ',
                    decimal: ',',
                });
            default:
                return Object.assign(options, {
                    separator: ',',
                    decimal: '.',
                });
        }
    }

    isInViewport() {
        const rect = this.element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    animate() {
        if (!this.counter.error) {
            this.counter.start();
        } else {
            console.error(this.counter.error);
        }
    }
}
